/**
 * Pre-configured themes for known sites.
 * Import these in standalone App.js or host apps that need site-specific theming.
 * These are NOT bundled with the module federation exports.
 *
 * Simplified theme structure - only specify values that differ from defaults.
 * Core colors (primary, primaryDark) drive most derived values automatically.
 */

/**
 * WireCare theme configuration
 * Uses default blue palette - most values derived automatically
 */
export const wirecareTheme = {
  name: 'WireCare®',

  colors: {
    // Core palette
    primary: '#5a83a1',
    primaryDark: '#0a3257',

    // Navigation
    navBackground: '#8bb8d1',
    navDivider: '#b2d0e0',
    navActiveBackground: '#fff',

    // Modal (slightly different shade)
    modalHeaderBackground: '#8cb7d0',
  },

  content: {
    footer: null,
    disclaimer: null,
  },
};

/**
 * Techflex theme configuration
 * Gray/black palette - overrides where defaults don't apply
 */
export const techflexTheme = {
  name: 'Techflex®',

  colors: {
    // Core palette (both gray since there's no accent color)
    primary: '#696969',
    primaryDark: '#696969',

    // Navigation (white text on gray)
    navBackground: '#696969',
    navDivider: '#888',
    navText: '#fff',
    navActiveBackground: '#fff',
    navActiveText: '#696969',

    // General
    headerText: '#000',

    // Primary button (black instead of gray)
    buttonPrimary: '#000',
    buttonPrimaryHover: '#333',

    // Outline button (filled gray style, not transparent)
    buttonOutlineBackground: '#d9d9d9',
    buttonOutlineBorder: '#d9d9d9',
    buttonOutlineText: '#000',
    buttonOutlineHoverBackground: '#696969',
    buttonOutlineHoverBorder: '#696969',
    buttonOutlineHoverText: '#fff',
  },

  content: {
    footer: null,
    disclaimer: null,
  },
};
